// modules
import { handleActions } from 'redux-actions'

// actions
import {
  resetActivityDashboard,
  setActivityBillingStatistic,
  setActivityDashboardData,
  setActivityDashboardStatistic,
  setActivityDashboardStatistics,
  setActivityDashboardSummary,
  setBillingCodes,
  setDashboardMeasurementList,
  setIsStatisticLoading,
  setPredefinedActivityDashboardFilter
} from 'src/store/modules/admin/activityDashboard'

const initialState = {
  activityList: [],
  statistics: {},
  activitySummary: {},
  activityStatistic: {},
  billingCodes: [],
  activityBillingStatistic: {},
  isStatisticLoading: false,
  predefinedActivityDashboardFilter: {},
  dashboardMeasurementList: []
}

export default handleActions(
  {
    [setActivityDashboardData](state, { payload: activityList }) {
      return {
        ...state,
        activityList
      }
    },
    [setActivityDashboardStatistics](state, { payload }) {
      return {
        ...state,
        statistics: payload
      }
    },

    [setActivityDashboardSummary](state, { payload: activitySummary }) {
      return {
        ...state,
        activitySummary
      }
    },

    [setActivityDashboardStatistic](state, { payload: activityStatistic }) {
      return {
        ...state,
        activityStatistic
      }
    },

    [setBillingCodes](state, { payload: billingCodes }) {
      return {
        ...state,
        billingCodes
      }
    },

    [setActivityBillingStatistic](
      state,
      { payload: activityBillingStatistic }
    ) {
      return {
        ...state,
        activityBillingStatistic
      }
    },

    [setIsStatisticLoading](state, { payload: isStatisticLoading }) {
      return {
        ...state,
        isStatisticLoading
      }
    },

    [setPredefinedActivityDashboardFilter](
      state,
      { payload: predefinedActivityDashboardFilter }
    ) {
      return {
        ...state,
        predefinedActivityDashboardFilter
      }
    },

    [setDashboardMeasurementList](
      state,
      { payload: dashboardMeasurementList }
    ) {
      return {
        ...state,
        dashboardMeasurementList
      }
    },

    [resetActivityDashboard]() {
      return initialState
    }
  },
  initialState
)
